import React from 'react';
import ReactTooltip from 'react-tooltip';
import clsx from 'clsx';
import {PdfViewer} from "presentation/common";
import {DownloadIcon} from "presentation/common/components/style-guide/icons";
import {FileDetails} from './file-details';

import styles from './styles.module.scss';

export const DesktopView = props => {
  const {documents, detailInfo, onDelete, onDownloadDocuments} = props;

  return (
    <>
      <ReactTooltip
        backgroundColor="white"
        border
        borderColor="var(--primary)"
        effect="solid"
        id="downloadTooltip"
        textColor="var(--primary)"
        type="info">
        Descargar
      </ReactTooltip>

      <div className="flex flex-col h-full w-full overflow-hidden p-4">
        <div className="pb-2 flex justify-between items-center">
          <p className="text-primary text-lg">
            DETALLES SOLICITUD
          </p>
        </div>
        <main className={clsx('h-full w-full flex-1 flex-auto grid gap-3 pb-6', styles.body)}>
          <PdfViewer elements={documents} onDelete={onDelete} onDownloadDocuments={onDownloadDocuments}>
            <div className="flex gap-3">
              <DownloadIcon
                className="cursor-pointer focus:outline-none"
                data-for="downloadTooltip"
                data-tip
                onClick={onDownloadDocuments}
              />
            </div>
          </PdfViewer>

          <FileDetails detailInfo={detailInfo} />
        </main>
      </div>
    </>
  );
};
